import '../components/patch.js';
import '../components/alert.js';

let sonikit;
export const init = (instance) => {
  sonikit = instance;
  // Start observing when the module initializes
  observePatches();
}

function renderPatches() {
  sonikit.project.patches.forEach(async patch => {
    const target = document.querySelector(`.sonikit-patch[data-id="${patch._id}"]`);
    if (target && target.dataset.state !== 'loading' && target.dataset.state !== 'ready') {
      target.dataset.state = 'loading';

      let embed;
      if (patch.action === 'collect-contact') {
        embed = document.createElement('sonikit-contact');
      } else {
        embed = document.createElement('sonikit-patch');
      }
      embed.setAttribute('patch-id', patch._id);
      // target.replaceWith(embed);
      target.appendChild(embed);
      embed.patch = patch;
    }
  })
}

function scanForPatches() {
  const idlePatches = document.querySelectorAll('.sonikit-patch:not([data-state="loading"]):not([data-state="ready"])');
  if (idlePatches.length > 0) {
    renderPatches();
  }
}

function observePatches() {
  // MutationObserver for detecting DOM changes
  const observer = new MutationObserver(scanForPatches);
  observer.observe(document.body, { childList: true, subtree: true });

  // URL change detection (for SPAs)
  let lastUrl = window.location.href;
  const checkUrlChange = () => {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      scanForPatches();
    }
  };

  // Intercept pushState and replaceState (for frameworks that don't trigger popstate)
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    checkUrlChange();
  };
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    checkUrlChange();
  };

  // Listen for back/forward navigation
  window.addEventListener('popstate', checkUrlChange);

  // Fallback interval to catch missed updates
  setInterval(scanForPatches, 2000); // Run every 2 seconds as a last resort

  // Initial scan in case elements are already present
  scanForPatches();
}

function showConfirmation(patch, service) {
  let message;
  if ((patch.action === 'save-media' || patch.action === 'feed') && service.media_type) {
    const media_type = patch.action === 'feed' && service.media_type === 'podcast' ? 'episode' : service.media_type;
    message = `${media_type.charAt(0).toUpperCase() + media_type.slice(1)} saved!`;
  } else if (patch.action === 'follow' && service.media_type) {
    message = `${service.media_type.charAt(0).toUpperCase() + service.media_type.slice(1)} followed!`
  } else if (patch.action === 'presave' && service.media_type) {
    const today = new Date()
    const release_date = new Date(patch.release_date)
    if (today <= release_date) {
      message = `Release pre-saved!`
    } else {
      message = `Release saved!`
    }
  } else if (patch.action === 'reward' && service.media_type) {
    message = `${service.media_type.charAt(0).toUpperCase() + service.media_type.slice(1)} unlocked!`
  } 
  
  if (!message && patch.action === 'presave') {
    // Service is not being saved with media_type when presaves are created manually
    const today = new Date()
    const release_date = new Date(patch.release_date)
    if (today <= release_date) {
      message = `Release pre-saved!`
    } else {
      message = `Release saved!`
    }
  }
  
  if (message) {
    const alert = document.createElement('sonikit-alert');
    document.body.appendChild(alert);
    alert.setContent(message);

    setTimeout(() => {
      if (alert) alert.remove();
    }, 3000);
  }
}

function unlockContent(patch_id, adapter, data) {
  const target = document.querySelector(`.sonikit-patch[data-id="${patch_id}"]`);
  if (!target) {
    return console.log('No reward target')
  }

  const reward_target = target.querySelector('[data-role="patch-reward"]');
  if (!reward_target) {
    return console.log('No reward target')
  }

  const service = adapter.services[0];
  if (!service) {
    return console.log('No reward service')
  }

  const auth_target = target.querySelector('[data-role="patch-auth"]');
  if (auth_target) {
    auth_target.innerHTML = "";
    auth_target.remove();
  }

  target.dataset.state = 'loading';

  const shadow = reward_target.attachShadow({mode: "closed"});
  
  let style = document.createElement("style");
  style.textContent = `
    .wrapper { 
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;
      box-sizing: border-box;
    }
    .unlocked-message {
      text-align: center;
      margin-bottom: 10px;
      font-weight: 800;
    }
    
    .unlocked-content {
      width: 500px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    @media (max-width: 500px) {
      .unlocked-content {
        width: 90%;
      }
    }
    
    .unlocked-content button,
    .cta-button {
      background-color: black;
      color: white;
      padding: 8px 16px;
      font-weight: 800;
      border-radius: 4px;
      box-sizing: border-box;
      outline: none;
      border: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    
    .loading {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
    }
    
    .aspect-wrap {
      position: relative;
      padding-bottom: 56.25%;
      background-color: black;
      width: 100%;
      margin: auto;
    }
    
    .aspect-wrap video,
    .aspect-wrap iframe {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
    }
    
    .discount-code {
      font-size: 2em;
      font-weight: 800;
      padding: 8px 16px;
      border-radius: 4px;
      box-sizing: border-box;
      border: 1px solid #EAEAEA;
      background-color: white;
      margin: 5px auto;
    }
  `
  shadow.appendChild(style);
  
  const wrapper = document.createElement('div');
  wrapper.className = 'wrapper';
  
  const message = document.createElement('div');
  message.classList = 'unlocked-message';
  message.innerHTML = `${service.media_type.charAt(0).toUpperCase() + service.media_type.slice(1)} unlocked! 🎉`;
  wrapper.appendChild(message);

  const contentWrap = document.createElement('div');
  contentWrap.classList = 'unlocked-content';

  if (service.media_type === 'video') {
    contentWrap.innerHTML = `
      <div class="aspect-wrap">
        <div class="loading">Loading...</div>
        <iframe src="https://www.youtube.com/embed/${service.media_id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen autoplay></iframe>
      </div>
    `
  } else if (service.media_type === 'discount' && data) {
    if (adapter.cta_url) {
      contentWrap.innerHTML = `
        <div class="discount-code">${data.code}</div>
        <a href="${adapter.cta_url}" class="cta-button">Shop Now</a>
      `
    } else {
      contentWrap.innerHTML = `
        <div class="discount-code">${data.code}</div>
      `
    }
  }
  wrapper.appendChild(contentWrap);

  shadow.appendChild(wrapper);
  target.dataset.state = 'ready';
  
  const patch = { id: patch_id, action: 'reward' };
  showConfirmation(patch, service);
}

export { showConfirmation, unlockContent}